var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('h4',{staticClass:"mb-0",attrs:{"slot":"header"},slot:"header"},[_vm._v(" "+_vm._s(_vm.featureName)+" "),_c('span',{staticClass:"badge bg-primary"},[_vm._v("Disponibile a breve")])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }